import {UI} from "../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {Router} from "../../../stem-core/src/ui/Router";
import {PaymentMethodStore} from "../../State";
import {WidgetRoutes} from "../WidgetRoutes";
import {Messages} from "../../Messages";
import {ActiveCardInfo} from "../../common/ActiveCardInfo";


class CardInlineStyle extends StyleSheet {
    @styleRule
    element = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
    };

    @styleRule
    change = {
        fontSize: 14,
        cursor: "pointer",
        whiteSpace: "nowrap",
        display: "flex",
        alignItems: "center",
    };
}

@registerStyle(CardInlineStyle)
export class CardInline extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            hideIcon: false,
            linkColor: this.styleSheet.themeProps.WALLET_LINK,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.element);
    }

    render() {
        const {styleSheet} = this;
        const {linkColor, hideIcon} = this.options;
        const card = PaymentMethodStore.getPrimary();

        const onCardChangeClick = (event) => {
            event.stopPropagation();
            Router.changeURL(PaymentMethodStore.getPrimary() ? WidgetRoutes.CHOOSE_CARD : WidgetRoutes.ADD_CARD);
        }

        return [ // Testing purposes.
            card ? <ActiveCardInfo testId="walletPrimaryCardDetails" card={card} hideIcon={hideIcon}/> : null,
            <div testId="walletChangeCardButton" className={styleSheet.change} style={{color: linkColor}}
                 onClick={onCardChangeClick}>
                {card ? Messages.change : Messages.addCardInlineWidget}
            </div>
        ];
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(PaymentMethodStore, () => this.redraw());
    }
}
